/* eslint-disable import/extensions */
import { getFontSection, fontSectionEnum } from './font-section.js';
import { TITLE_AND_CONTAINER_PROP } from './titleAndContainerProperties.js';

const fontConfig = getFontSection(
	{
		fontName: TITLE_AND_CONTAINER_PROP.TITLEBAR_FONT_FAMILY,
		fontSize: TITLE_AND_CONTAINER_PROP.TITLEBAR_FONT_SIZE,
		fontColor: TITLE_AND_CONTAINER_PROP.TITLEBAR_FONT_COLOR,
		fontStyle: TITLE_AND_CONTAINER_PROP.TITLEBAR_FONTSTYLE,
		textAlignment: TITLE_AND_CONTAINER_PROP.TITLEBAR_TEXT_ALIGNMENT,
		textAlignmentStyle: 'toggle-button-radio _3item',
		textAlignmentOptions: ['align-left', 'align-center', 'align-right']
	},
	[
		fontSectionEnum.NAME_SELECT,
		fontSectionEnum.STYLE,
		fontSectionEnum.SIZE_AND_COLOR,
		fontSectionEnum.HORIZONTAL_ALIGN
	],
	{},
	{
		colorPickerClassName: 'sankey__container-config'
	}
);

const containerLayout = {
	tagName: 'VerticalLayout',
	className: 'container-layout',
	children: [
		{
			tagName: 'Text',
			className: 'section-header-text',
			text: 'Container'
		},
		{
			tagName: 'HorizontalLayout',
			className: 'container-fill-layout',
			children: [
				{
					tagName: 'Text',
					text: 'Fill'
				},
				{
					tagName: 'ColorPicker',
					key: TITLE_AND_CONTAINER_PROP.CONTAINER_FILL_COLOR,
					className: 'sankey__container-config'
				},
				{
					tagName: 'InputNumber',
					value: 100,
					format: '%',
					min: 0,
					max: 100,
					key: TITLE_AND_CONTAINER_PROP.CONTAINER_BORDER_OPACITY
				}
			]
		},
		{
			tagName: 'HorizontalLayout',
			className: 'border-fill-layout',
			children: [
				{
					tagName: 'Text',
					text: 'Border'
				},
				{
					tagName: 'Select',
					ariaLabel: { desc: 18345, name: 'Border' },
					innerClassName: 'lines',
					key: TITLE_AND_CONTAINER_PROP.CONTAINER_BORDER_STYLE,
					// TODO change name if needed - discuss with translation team
					options: [
						{ desc: 2997, name: 'None', value: 'none' },
						{ name: '1pt dotted', value: '1pt dotted' },
						{ name: '1pt dashed', value: '1pt dashed' },
						{ name: '1pt solid', value: '1pt solid' },
						{ name: '2pt solid', value: '2pt solid' }
					],
					icons: ['none', 'dot', 'dash', 'solid', 'solid-thick']
				},
				{
					tagName: 'ColorPicker',
					key: TITLE_AND_CONTAINER_PROP.CONTAINER_BORDER_COLOR,
					className: 'sankey__container-config'
				}
			]
		}
	]
};

const positionAndSizeLayout = {
	tagName: 'VerticalLayout',
	className: 'position-and-size-layout',
	key: TITLE_AND_CONTAINER_PROP.POSITION_AND_SIZE_SECTION,
	children: [
		{
			tagName: 'Text',
			className: 'section-header-text',
			text: 'Position and Size'
		},
		{
			tagName: 'VerticalLayout',
			children: [
				{
					tagName: 'HorizontalLayout',
					className: 'input-by-input',
					children: [
						{
							tagName: 'Text',
							text: 'X'
						},
						{
							// This is here to help with CSS so the other two text
							// components can be spaced correctly
							tagName: 'Text',
							text: ''
						},
						{
							tagName: 'Text',
							text: 'Y'
						}
					]
				},
				{
					tagName: 'HorizontalLayout',
					className: 'input-by-input',
					children: [
						{
							tagName: 'InputNumber',
							format: '%',
							key: TITLE_AND_CONTAINER_PROP.CONTAINER_LEFT_POSITION,
							min: 0,
							max: 100
						},
						{
							tagName: 'Text',
							text: 'x'
						},
						{
							tagName: 'InputNumber',
							format: '%',
							key: TITLE_AND_CONTAINER_PROP.CONTAINER_TOP_POSITION,
							min: 0,
							max: 100
						}
					]
				}
			]
		},
		{
			tagName: 'VerticalLayout',
			children: [
				{
					tagName: 'HorizontalLayout',
					className: 'input-by-input',
					children: [
						{
							tagName: 'Text',
							text: 'Width'
						},
						{
							// This is here to help with CSS so the other two text
							// components can be spaced correctly
							tagName: 'Text',
							text: ''
						},
						{
							tagName: 'Text',
							text: 'Height'
						}
					]
				},
				{
					tagName: 'HorizontalLayout',
					className: 'input-by-input',
					children: [
						{
							tagName: 'InputNumber',
							format: '%',
							key: TITLE_AND_CONTAINER_PROP.CONTAINER_WIDTH,
							min: 0,
							max: 100
						},
						{
							tagName: 'Text',
							text: 'x'
						},
						{
							tagName: 'InputNumber',
							format: '%',
							key: TITLE_AND_CONTAINER_PROP.CONTAINER_HEIGHT,
							min: 0,
							max: 100
						}
					]
				}
			]
		}
	]
};

const containerConfig = {
	tagName: 'VerticalLayout',
	className: 'title-and-container-layout',
	key: 'graphFont',
	children: [
		{
			tagName: 'HideableLayout',
			key: TITLE_AND_CONTAINER_PROP.TITLEBAR_SHOW,
			title: 'Title Bar',
			withSwitch: true,
			children: [
				{
					tagName: 'VerticalLayout',
					key: 'titleFontContent',
					children: [
						fontConfig,
						{
							tagName: 'HorizontalLayout',
							className: 'background-color-container',
							children: [
								{
									tagName: 'Text',
									text: 'Background'
								},
								{
									tagName: 'ColorPicker',
									key: TITLE_AND_CONTAINER_PROP.TITLEBAR_BACKGROUND_COLOR,
									className: 'sankey__container-config'
								}
							]
						}
					]
				}
			]
		},
		containerLayout,
		positionAndSizeLayout
	]
};

const containerConfigWithBackgroundOpacity = {
	tagName: 'VerticalLayout',
	className: 'title-and-container-layout',
	children: [
		{
			tagName: 'HideableLayout',
			key: TITLE_AND_CONTAINER_PROP.TITLEBAR_SHOW,
			title: 'Title Bar',
			withSwitch: true,
			children: [
				{
					tagName: 'VerticalLayout',
					children: [
						fontConfig,
						{
							tagName: 'Text',
							text: 'Background'
						},
						{
							tagName: 'HorizontalLayout',
							className: 'background-color-container',
							children: [
								{
									tagName: 'ColorPicker',
									key: TITLE_AND_CONTAINER_PROP.TITLEBAR_BACKGROUND_COLOR,
									className: 'sankey__container-config'
								},
								{
									tagName: 'InputNumber',
									format: '%',
									min: 0,
									max: 100,
									value: 100
								}
							]
						}
					]
				}
			]
		},
		containerLayout,
		positionAndSizeLayout
	]
};

const containerNoFontConfig = {
	tagName: 'VerticalLayout',
	className: 'title-and-container-layout',
	children: [containerLayout, positionAndSizeLayout]
};

export {
	containerConfig,
	containerNoFontConfig,
	positionAndSizeLayout,
	containerConfigWithBackgroundOpacity
};
